export default __webpack_public_path__ + "static/media/FriCo-logo-app-colormatched-vertical.b942270f.svg";